<template>
	<card :type="strAccessType" class="ReSearchCardPlanHelp mr-2" v-if="typeof site.description != 'undefined' && site.description != ''">
		<div class="card-header p-0 mb-3">
			<img class="main-photo" v-if="site.photo && site.photo.length>0" :src="site.photo[0].fullpath" />
		</div>
		<div class="card-user">
			<div class="left_part">
				<div class="avatarBlk author">
					<div class="roles">
						<span class="badge badge-pill badge-success">{{site.site}}</span>
						<span class="badge badge-pill badge-primary">{{site.term}}</span>
					</div>
				</div>
				<div class="fioBlk">
					<div>
						<!-- h4 class="title">{{strFIO}}</h4 -->
						<p class="description">{{ site.description }}</p>
					</div>
				</div>
			</div>
		</div>
	</card>
</template>

<script>
	export default {
		name: 'ReSearchCardPlanHelp',
		components: {
		},
		props: {
			site: Object,
		},
		data () {
			return {
				ver: 1,
			}
		},
		computed: {
			
		},
		methods: {
			
		},
	}
</script>
<style scoped>
	.ReSearchCardPlanHelp {
		border: 1px solid #9e77f3;  
		box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25)!important;
		margin-bottom: 10px;
		max-width: 580px;
	}

	.ReSearchCardPlanHelp .main-photo { max-height: 170px;}
	.ReSearchCardPlanHelp .card-header {text-align: center;}
	
	.ReSearchCardPlanHelp .card-user{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	.card-user .author{margin-top: 0px;}
	.card-user .left_part, .card-user .right_part{
		width: 100%;
		display: flex;
		flex-flow: row nowrap;
	}
	/*.card-user .left_part{}*/
	.card-user .right_part{justify-content: space-between;}
	.card-user .right_part > *{display: inline-block; vertical-align: top;}

	.avatarBlk{min-width:150px;}
	.avatarBlk .avatar{
		object-fit: contain;
		background-color: white;
		border-radius: 0.2857rem;
		border: 0px;
		border-bottom-color: inherit;
	}
	
	.onlineStatus{text-align: center;}
	.onlineStatus > *{display: inline-block;}
	.onlineStatus i{
		width: 7px;
		height: 7px;
		border-radius: 50%;
		margin-right: 5px;
	}
	.onlineStatus.online i{background-color: greenyellow;}
	.onlineStatus.offline i{background-color: red;}

	.fioBlk {display: flex; flex-direction: column; justify-content: space-between;}

	p.description{font-size: 1em;}
	p.description a > i{ margin-right: 5px;}

	.roles {
		display: flex;
		flex-direction: column;
		padding: 0 15px 0 5px;
		align-items: center;
	}
	.roles .badge {width: fit-content;}


	@media (max-width: 1100px){
		.card-user .orgBlk{display:none;}
	}
	@media (max-width: 600px){
		.ReSearchCardPlanHelp .card-user{
			display: block;
		}
		.card-user .left_part, .card-user .right_part{display: block;}
	}
</style>
